import { AverageMetricHookParams } from '@va/dashboard/api-client/visitor-stats';
import { useCurrentPeriodFilter, usePreviousPeriodFilter, usePreviousYearPeriodFilter } from '@va/dashboard/util-hooks';
import { useFiltersContext } from '@va/shared/feature-filters';
import { DateComparisonPeriod } from '@va/ui/components/report-block';
import { useMemo } from 'react';

export const useCurrentVisitorStatsParams = (): AverageMetricHookParams => {
  const { from, until, unit } = useCurrentPeriodFilter();
  const { createApiConditions } = useFiltersContext();

  return useMemo(
    () => ({ dateRange: { start: from as string, end: until as string }, unit, where: { and: createApiConditions() } }),
    [from, until, unit, createApiConditions],
  );
};

export const usePreviousVisitorStatsParams = (
  activeComparisonOption: DateComparisonPeriod,
): AverageMetricHookParams => {
  const previousHook = useMemo(
    () => (activeComparisonOption === DateComparisonPeriod.YOY ? usePreviousYearPeriodFilter : usePreviousPeriodFilter),
    [activeComparisonOption],
  );
  const { from, until, unit } = previousHook();
  const { createApiConditions } = useFiltersContext();

  return useMemo(
    () => ({ dateRange: { start: from as string, end: until as string }, unit, where: { and: createApiConditions() } }),
    [from, until, unit, createApiConditions],
  );
};
